import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { useMemo } from 'react';
import { useQuoteTrackClick } from '../../../utils/quote/useQuoteTracking';
import styles from './OptionTabs.module.scss';

type OptionTabsProps = {
  activeTab?: string;
  companyStandardName?: string;
  symbol: string;
};

const getTabDefinitions = (t: TFunction, symbol: string) => [
  {
    href: `/quote/${symbol}/option-chain`,
    key: 'option-chain',
    label: t('Quote.OptionChain.option-tab'),
  },
  {
    href: `/quote/${symbol}/unusual-options`,
    key: 'unusual-options',
    label: t('Quote.OptionChain.unusual-options-tab'),
  },
];

const OptionTabs = ({ activeTab = '', symbol }: OptionTabsProps) => {
  const { t } = useTranslation('quote');
  const trackClick = useQuoteTrackClick();

  const tabs = useMemo(() => getTabDefinitions(t, symbol), [t, symbol]);

  return (
    <div className={styles.optionChainTabs}>
      <div>
        {tabs.map(tab => (
          <span className={`${styles.optionTab}${tab.key === activeTab ? ' active' : ''}`} key={tab.key}>
            <a
              href={tab.href}
              onClick={e => {
                if (tab.key === activeTab) {
                  e.preventDefault();
                  return;
                }
                trackClick('option_subtab_nav');
              }}
            >
              {tab.label}{' '}
            </a>
          </span>
        ))}
      </div>
    </div>
  );
};

export default OptionTabs;
